module.exports = __webpack_public_path__ + "img/pop.81a4b277.png";